import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getPaymentTransactions} = api.payment;

type Params = Parameters<typeof getPaymentTransactions>[0] | null;

const getPaymentTransactionsRefresh = atom<number>({
  key: 'getPaymentTransactionsRefresh',
  default: 0,
});

const getPaymentTransactionsQuery = selectorFamily({
  key: 'getPaymentTransactions',
  get(params: Params) {
    return async ({get}) => {
      get(getPaymentTransactionsRefresh);
      try {
        const {data} = await getPaymentTransactions(params ?? undefined, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetPaymentTransactionsQuery = createQuery(getPaymentTransactionsQuery, getPaymentTransactionsRefresh);
